<template>
  <div>
    <!-- <div ref="lineChart" id="lineDiv"></div> -->
    <div v-for="(item, index) in ls" :key="index" :ref="'chartRef' + index"></div>
  </div>
</template>

<script>
import { lineOption } from "@/views/report/indicators/option/lineOption"
import * as echarts from "echarts";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      chartRefs: []
    }
  },
  props: {
    ls: {
      type: Array
    }
  },
  computed: {
    ...mapGetters(['lineData']),
  },
  watch: {
    lineData: {
      deep: true,
      handler(newVal, oldVal) {
        this.initCharts();

      }
    }
  },
  methods: {
    getIndexMsg() {
      this.initCharts();
    },
    initCharts() {
      this.chartRefs.forEach(chart => {
        if (chart && chart._resizeHandler) {
          window.removeEventListener('resize', chart._resizeHandler);
        }
        chart.dispose();
      });
      this.chartRefs = [];

      this.ls.forEach((seriesItem, index) => {
        const chartDom = this.$refs['chartRef' + index][0]; // 注意这里是个数组

        if (!chartDom) return;

        chartDom.style.height = (document.documentElement.clientHeight - 120) / 2 + 'px';
        chartDom.style.border = '1px solid #ccc';

        const myChart = echarts.init(chartDom);

        const option = JSON.parse(JSON.stringify(lineOption));
        const data = this.lineData[seriesItem.code];
        option.xAxis[0].data = Object.keys(data).map(key => '周' + key);
        const _series = option.series[0]
        _series.name = seriesItem.name;
        _series.data = Object.values(data).map(value => (parseFloat(value) * 100).toFixed(0))
        option.series = [_series];
        option.legend.data = [seriesItem.name];
        myChart.setOption(option);
        this.chartRefs.push(myChart);

        const resizeHandler = () => {
          myChart.resize();
        };

        window.addEventListener('resize', resizeHandler);
        myChart._resizeHandler = resizeHandler;
      });
    }
  },
  created() {

  },
  mounted() {

    // this.getIndexMsg();
  }
}
</script>

<style lang=scss>
// #lineDiv {
//   width: 500px;
//   height: 300px;
//   border: 1px solid red;
// }</style>